import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initQuantityInputs from '../components/quantityInputs';
import initProductVariants from '../components/product-variants';
import initRelatedProducts from '../sections/product/related-products';
import initProductStickyAtc from '../components/product-sticky-atc';
import initProductVideo from '../components/product-video';
import initKlaviyoBis from '../sections/product/klaviyo-bis';
import initProductLightbox from '../sections/product/product-lightbox';
import initDeliveryEstimate from '../sections/product/delivery-estimate';
import initGiftCardRecipient from '../components/gift-card-recipient';
import initLinkedProductSelect from '../sections/product/linked-product-select';
import initProductShortDescription from '../sections/product/short-description';
import initProductSharing from '../sections/product/product-sharing';
import initProductUpsellTabs from '../sections/product/upsell-tabs';
import initRechargeWidget from '../sections/product/recharge-widget';
import renderMinicart from '../lib/renderMinicart';

/** Configure and initialise PDP related products swiper. */
const initPdpRelatedProducts = () => {
  initRelatedProducts({
    containerSelector: '[data-related-products]',
    swiperSelector: '[data-swiper]',
    swiperMobile: false,
    onAddSuccess: async ({ item, cart } = {}) => {
      await renderMinicart();
      window.theme.cartToast?.show({ cartTotal: cart?.total_price, item });
    }
  });
};

/** Run all PDP initialisers. Each function guards against double-init internally. */
const initAll = () => {
  initQuantityInputs();
  initProductVariants();
  initPdpRelatedProducts();
  initProductStickyAtc();
  initProductVideo();
  initKlaviyoBis();
  initLinkedProductSelect();
  initProductShortDescription();
  initProductSharing();
  initProductUpsellTabs();
  initProductLightbox();
  initDeliveryEstimate();
  initGiftCardRecipient();
  initRechargeWidget();
};

// ---------------------------------------------------------------------------
// Init
// ---------------------------------------------------------------------------

ready(initAll);

// Re-init everything on Shopify section reload — each init guards against duplication
onShopifySectionLoad(initAll);
